import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  neoAssistWidgetSrc,
  NEOASSIST_CLIENT_DOMAIN,
  NEOASSIST_CENTRAL_PATH,
  NEOASSIST_RESTORE_FLOATING_EVENT,
} from '@/lib/neoAssistSdk';

const ENABLE = import.meta.env.VITE_ENABLE_NEOASSIST === 'true';

function unload(): void {
  window.NeoAssistTag = undefined;
  window.NeoAssistTagLoaded = false;
  window._NAWidgetLoaded = [];
  document.getElementById('neoassist-widget-loader')?.remove();
  document.querySelector('iframe.neoasssist-widget-frame')?.remove();
  document
    .querySelectorAll('[id*="neoassist-widget-frame"], [class*="neoasssist"]')
    .forEach((el) => el.remove());
}

function loadFloating(): void {
  unload();
  window.NeoAssistTag = { querystring: true, pageid: '', clientdomain: NEOASSIST_CLIENT_DOMAIN };
  const script = document.createElement('script');
  script.id = 'neoassist-widget-loader';
  script.async = true;
  script.src = neoAssistWidgetSrc();
  document.body.appendChild(script);
}

export function NeoAssistWidget(): null {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!ENABLE) return;
    if (!pathname.startsWith(NEOASSIST_CENTRAL_PATH)) loadFloating();
    return () => unload();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!ENABLE) return;
    const restore = (): void => loadFloating();
    window.addEventListener(NEOASSIST_RESTORE_FLOATING_EVENT, restore);
    return () => window.removeEventListener(NEOASSIST_RESTORE_FLOATING_EVENT, restore);
  }, []);

  return null;
}
